<template>
    <div class="w100 pl20 bg-w pr20 pt20 pb20" v-loading="loading">

        <div class="search-warp">
            <el-form :inline="true" label-width="60px"class="">
                <el-form-item label="主题" >
                    <by-page-select
                            ref="pageSelect"
                            :leftData="subjectList"
                            :total="subjectTotal"
                            multiple
                            title="主题选择"
                            collapseTags
                            :paramSearch="subjectParamSearch"
                            @handleCurrentChange="handleCurrentChange"
                            @handleSizeChange="handleSizeChange"
                            @setValue="setValue"
                            >
                        <el-input
                                style="margin-bottom: 4px;width: 300px"
                                slot="header"
                                placeholder="请输入主题"
                                v-model="subjectParamSearch.name"
                                @keyup.enter.native="subPage">
                        </el-input>
                    </by-page-select>
                </el-form-item>
                <el-form-item label="部门" >
                    <TreeSelect size="small"
                                :data="departmentData"
                                clearable
                                width="300px"
                                collapseTags
                                multiple
                                expandAll
                                ref="deptDouble"
                                :obj="mapKey"
                                checkStrictly
                                @getValue="setDeptDoubleMenu"></TreeSelect>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="searchFn">查询</el-button>
                </el-form-item>

            </el-form>
        </div>
        <div class="table-con advice-main">
            <el-table class="w100 mt20 table" header-row-class-name="table-head"
                      row-class-name="cu-p" stripe :data="list" >
                <el-table-column align="center"  label="留言">
                    <template slot-scope="scope">
                        <span v-text="scope.row.msgContent" class="ellipsis"></span>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="serveName" label="所涉服务"></el-table-column>
                <el-table-column align="center" prop="deptName" label="涉及部门"></el-table-column>
                <el-table-column align="center" prop="createTime" width="150px" label="创建时间">
                </el-table-column>
                <el-table-column align="center"   label="回复内容">
                    <template slot-scope="scope">
                        <span v-text="scope.row.answerContent" class="ellipsis"></span>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="answerTime" width="150px" label="回复时间">

                </el-table-column>
                <el-table-column align="center"   label="状态">
                    <template slot-scope="scope">
                        <el-tag type="success" size="small" v-if="scope.row.status == '已处理'">已处理</el-tag>
                        <el-tag type="danger" size="small"  v-if="scope.row.status == '未处理'">未处理</el-tag>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="refuseIP" width="200px" label="操作">
                    <template slot-scope="scope">
                        <div class="to-use">
                            <span class="info" @click="openDetail(scope.row)" >查看详情</span>
                            <span class="info" @click="openAddLeave(scope.row)"  v-if="scope.row.status == '已处理'">新增留言</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div class="mt20 flex-box">
            <div class="flex-1"></div>
            <el-pagination background @size-change="changeSize"
                           @current-change="changePage"
                           :current-page="paramSearch.current"
                           :page-sizes="pageSizes"
                           :page-size="paramSearch.size"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total"
            ></el-pagination>
        </div>
        <!-- 详情、新增 -->
        <AddLeave ref="addLeave" @saveSuccess="saveSuccess"/>
        <!-- 详情、新增 -->
        <answer-msg-dialog ref="answerMsgDialog" @saveSuccess="saveSuccess"/>
    </div>
</template>

<script>
    import AddLeave from "@/views/management/advice/addLeave";
    import byPageSelect from "@/components/byPageSelect.vue";
    import TreeSelect from "@/components/TreeSelect.vue";
    import answerMsgDialog from "@/views/mine/voiceMessage/answerMsgDialog.vue";
    import { getLeaveMsgList} from '@/api/personalCenter/suggestAngMsg';
    import { getDeptTree} from '@/api/managementCenter/otherApi';
    import { getSubjectList} from '@/api/managementCenter/themeManage';

    export default {
        name: "VoiceMessage",
        components: {
            byPageSelect,
            TreeSelect,
            answerMsgDialog,
            AddLeave
        },
        props: [],
        data() {
            return {
                loading: false,
                list: [],
                pageSizes:[10, 20, 30, 50, 100],
                paramSearch:{
                    current:1,
                    size:10,
                    depts:[],
                    subjects:[]
                },
                total: 0,
                subjectList:[],
                subjectParamSearch:{
                           current:1,
                           size:10,
                           name:""
                        },
                subjectTotal: 0,
                siftData : [
                    {
                        type: "text",
                        key: "name",
                        label: "主题名称",
                        placeholder: "请输入主题名称",
                        default: ""
                    }
                ],
                departmentData:[],
                mapKey:{
                    id:'id',// ID
                    label: 'name',// 显示名称
                    children: 'children', //子级字段名
                },


            };
        },
        computed: {},
        created() {},
        mounted() {

            this.getListFn();
            this.getSubjectList()
            this.getDeptTreeData()
        },
        methods: {
            getDeptTreeData() {
                getDeptTree().then(({data}) => {
                    if (data.code == 0) {
                        this.departmentData = data.data
                    }
                }).catch(err => {

                })

            },
            getSubjectList() {
                this.$refs.pageSelect.setToading(true)
                getSubjectList(this.subjectParamSearch)
                    .then(({data}) => {
                        this.$refs.pageSelect.setToading(false)
                        if (data.code == 0) {
                            const list = data.data.records || []
                            this.subjectList = list.map(i => {
                                return {value: i.id, name: i.name}
                            })
                            this.subjectTotal = data.data.total;
                        }
                    }).catch(err => {
                    this.$refs.pageSelect.setToading(false)
                })
            },
            handleCurrentChange(value) {
                this.subjectParamSearch.current = value;
                this.getSubjectList();
            },
            handleSizeChange(value) {
                this.subjectParamSearch.size = value;
                this.subjectParamSearch.current = 1;
                this.getSubjectList();
            },
            subPage() {
                this.subjectParamSearch = {
                    ...this.subjectParamSearch,
                    current: 1
                }
                this.getSubjectList();
            },
            setValue(data) {
                this.paramSearch.subjects = data
            },

            setDeptDoubleMenu(key,data){
                this.paramSearch.depts = data.map(item=>item.id)
            },

            // 获取查询列表
            getListFn() {
                this.loading = true;

                getLeaveMsgList(this.paramSearch).then(({data}) => {
                    this.loading = false;
                    if (data.code == 0) {
                        this.list = data.data.records || []
                        this.total = data.data.total;
                    } else {
                        this.$message.warning(data.msg||"加载失败！");
                    }
                }).catch(() => {
                        this.$message.error("加载异常！");
                        this.loading = false;
                    });
            },
            // 查询
            searchFn() {
                this.paramSearch = {
                    ...this.paramSearch,
                    current: 1
                }
                this.getListFn();
            },
            saveSuccess(){
                this.getListFn();

            },
            // 条数
            changeSize(value) {
                this.paramSearch.size = value;
                this.paramSearch.current = 1;
                this.getListFn();
            },
            // 翻页
            changePage(value) {
                this.paramSearch.current = value;
                this.getListFn();
            },
            openAddLeave(item){
                this.$refs.addLeave.dialogShow(item.serveId,item.serveName);
            },
            openDetail(data) {
                this.$refs.answerMsgDialog.dialogShow(data);
            }
        }
    };
</script>

<style scoped  lang="less">
    @import "../../../assets/css/handleBtn.less";
    .search-warp{
        height:40px ;
    }
    /deep/.el-table {
        width: 100%;
        .el-table__body-wrapper {
            max-height: calc(100vh - 300px);
            overflow-y: auto;

        }
    }
</style>

